
































































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { eventBus } from "@/utils/event";
import ShowYaml from "@/components/PrjAppCom/ShowYaml.vue";

import ContainerInfo from "@/components/PrjContainers/ContainerInfo.vue";
import { axios } from "@/plugins";

const headers: Header[] = [
  { title: "名称", key: "metadata.name", minWidth: 200 },
  { title: "状态", key: "", width: 120 },
  { title: "负载类型", key: "", width: 120 },
  { title: "组件名称", key: "", width: 220 },
  { title: "主机名称(IP)", key: "spec.nodeName", width: 220 },
  { title: "容器组IP", key: "", width: 150 },
  { title: "创建时间", key: "", width: 180 },
  { title: "操作", key: "", width: 100 }
];

const TypeOption = [
  { label: "有状态组件", value: "StatefulSet" },
  { label: "无状态组件", value: "Deployment" },
  { label: "任务", value: "Job" },
  { label: "定时任务", value: "CronJob" }
];
export default Vue.extend({
  name: "PrjContainers",
  components: { TableLayout, ContainerInfo, ShowYaml },
  props: { projectId: { type: String }, tenantId: { type: String } },
  data() {
    return {
      headers,
      isInit: false,
      showTools: true,
      disabled: false,
      loadType: "",
      value: "",
      TypeOption
    };
  },
  computed: {
    ...mapState("PrjContainers", ["total", "hasNext", "pageNum", "loading"]),
    ...mapGetters("PrjContainers", ["tableData"])
  },
  mounted() {
    this.getTable();
    this.getDetail();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("PrjContainers", [
      "getData",
      "pageTurn",
      "clear",
      "filterSearch"
    ]),
    getStatus(key: string) {
      switch (key) {
        case "Pending":
          return "加载中";
        case "Running":
          return "运行中";
        case "Succeeded":
          return "已完成";
        case "Failed":
          return "失败";
        case "Unknown":
          return "未知";
      }
    },
    getStatusColor(key: string) {
      switch (key) {
        case "Pending":
          return "orange";
        case "Running":
          return "green";
        case "Succeeded":
          return "blue";
        case "Failed":
          return "red";
        case "Unknown":
          return "gray";
      }
    },
    showInfo(data: any) {
      this.showTools = false;
      eventBus.$emit("setBeard", {
        name: "概览",
        is4Path: true,
        callback: () => {
          this.showTools = true;
          (this.$refs.containerInfo as any).close();
        }
      });
      (this.$refs.containerInfo as any).show(data);
    },
    getTable() {
      this.getData({
        url: "/pod/list/project",
        append: `&projectId=${this.projectId}&loadType=${this.loadType}&app=${this.value}`
      });
    },
    getDetail() {
      if (!this.$route.query.name) return;
      axios
        .get(
          `/pod/detail/project?name=${this.$route.query.name}&projectId=${this.projectId}`
        )
        .then(res => {
          this.showInfo(res.data.data);
        });
    },
    search() {
      this.filterSearch({
        append: `&projectId=${this.projectId}&loadType=${this.loadType}&app=${this.value}`
      });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "yaml":
          this.getYaml(data.metadata.name);
      }
    },
    getYaml(name: string) {
      this.$store.commit(`PrjContainers/SET_LOADING`, true);
      axios
        .get(`pod/${this.projectId}/${name}/yaml`)
        .then(res => {
          (this.$refs.showYaml as any).show(res.data.data, name);
        })
        .finally(() => {
          this.$store.commit(`PrjContainers/SET_LOADING`, false);
        });
    }
  }
});
